import { Icon, IconVariant } from '@/components/Icon';
import classnames from '@/utilities/classnames';
import React, { useEffect, useState } from 'react';

export const CouponNumber = (props: {
  index: string;
  value: number;
  width: string;
  isDisabled: boolean;
  isCrossed: boolean;
  ariaHidden?: boolean;
  onClick: (value: number) => void;
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleFocus = (event: FocusEvent) => {
      const isInsideCoupon = (event.target as HTMLElement).closest(
        '.CouponGroup__coupons '
      );
      if (isInsideCoupon) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };
    document.addEventListener('focusin', handleFocus);

    return () => {
      document.removeEventListener('focusin', handleFocus);
    };
  }, []);

  const changeElementStatus = () => {
    if (!props.isDisabled) {
      props.onClick(props.value);
    }
  };
  const handleOnClick = (
    $event: React.MouseEvent<HTMLElement> | React.KeyboardEvent
  ) => {
    $event.preventDefault();
    changeElementStatus();
  };

  const { isDisabled, isCrossed, value } = props;
  const couponNumberClass = classnames('CouponNumber', {
    'CouponNumber--disabled': isDisabled,
    'CouponNumber--crossed': isCrossed,
  });

  const width = props.width;
  const style = {
    width,
  };
  return (
    <div
      id={`couponNumber-${props.index}-${value}`}
      style={style}
      onClick={handleOnClick}
      className={couponNumberClass}
      tabIndex={isActive || isDisabled || props.ariaHidden ? -1 : 0}
      title={`${value}`}
      aria-hidden={props.ariaHidden}
      aria-label={
        props.ariaHidden
          ? ''
          : `Zahl ${value} - ${
              isCrossed ? 'angekreuzt' : 'klicken zum ankreuzen'
            }`
      }
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleOnClick(event);
        }
      }}
    >
      <Icon className="CouponNumber__cross" variant={IconVariant.Cross} />
      <span className="CouponNumber__value">{value}</span>
    </div>
  );
};
